<div class="resources">
  <router-outlet></router-outlet>
</div>
<!-- /.container resources -->
